import { useComponentRegistry } from '@bem-react/di';
import { ItemSimple } from '@yandex-lego/components/Menu';
import React, { ChangeEvent } from 'react';

import { TRegion } from 'client/common/types';
import cn from 'utils/cn';

import './index.css';

export interface IRegionSwitcherProps {
    tld: string;
    regions: TRegion[];
}

const b = cn('region-switcher');

function RegionSwitcher({ tld, regions }: IRegionSwitcherProps) {
    const { Select } = useComponentRegistry('lego');

    function wrapRegion({ url, name }: TRegion) {
        return {
            value: url,
            content: <span key={name} className={b('text')}>{name}</span>
        };
    }

    function handleChange(event: ChangeEvent<HTMLSelectElement>) {
        window.location.assign(event.target.value);
    }

    const currentName = regions.find(region => region.tld === tld)!.name;
    const options = [
        regions
            .filter(({ name }) => name !== currentName)
            .reduce((acc, region) => {
                acc.items = acc.items.concat(wrapRegion(region));

                return acc;
            }, { title: '', items: [] as ItemSimple[] })
    ];

    return (
        <div className={b()}>
            <Select
                view="classic"
                size="m"
                theme="normal"
                placeholder={currentName}
                onChange={handleChange}
                options={options}
                />
        </div>
    );
}

export default RegionSwitcher;
